import Promise from 'bluebird'
import Cookies from 'js-cookie'
import CreateReducer from '@nocode-works/template/store/utils/createReducer'
import CreateActions from '@nocode-works/template/store/utils/createActions'
import networkWrapper from '@nocode-works/template/store/utils/networkWrapper'
import {
  handlers,
} from '@nocode-works/template/store/utils/api'

import snackbarActions from '@nocode-works/template/store/modules/snackbar'
import routerSelectors from '@nocode-works/template/store/selectors/router'

const prefix = 'appsumo'
const wrapper = networkWrapper.factory(prefix)

const initialState = {
  email: '',
  plan: '',
  plans: [],
}

const reducers = {
  setEmail: (state, action) => {
    state.email = action.payload
  },
  setPlan: (state, action) => {
    state.plan = action.payload
  },
  setPlans: (state, action) => {
    state.plans = action.payload
  },
}

const sideEffects = {

  // if the cookies are still present we need to redirect to the /appsumo/activate page
  initialise: () => wrapper('initialise', async (state, action) => {
    const cookieEmail = Cookies.get('appsumo_email')
    const cookieUuid = Cookies.get('appsumo_uuid')
    
    if(cookieEmail && cookieUuid && window.location.pathname != '/appsumo/activate') {
      window.location.href = `/appsumo/activate?uuid=${encodeURIComponent(cookieUuid)}&email=${encodeURIComponent(cookieEmail)}`
    }
  }),

  // grab the uuid and activation email from the URL
  // check that this exists on the server
  // setup the login button to include the uuid and activation email in the google redirect
  activate: () => wrapper('activate', async (dispatch, getState) => {
    const route = routerSelectors.route(getState())
    if(!route) return
    const {
      uuid,
      email,
    } = route.params
    if(!uuid || !email) throw new Error('missing uuid or email')
    const status = await handlers.get(`/appsumo/status?uuid=${encodeURIComponent(uuid)}&email=${encodeURIComponent(email)}`)
    dispatch(actions.setEmail(status.email))
    dispatch(actions.setPlan(status.plan))
    // we write the cookie so the google callback can
    // pick up that we are activating an appsumo account
    // with this login
    // the server must have a single "activate" event
    // for this uuid and email for this to work
    // (to avoid someone just creating the cookie manually)
    Cookies.set('appsumo_email', email)
    Cookies.set('appsumo_uuid', uuid)
  }, {
    autoLoading: true,
  }),


  loadPlans: () => wrapper('loadPlans', async (dispatch, getState) => {
    const plans = await handlers.get(`/appsumo/plans`)
    dispatch(actions.setPlans(plans))
  }, {
    autoLoading: true,
  }),

}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export { actions, reducer }
export default actions